import React from 'react';

import './style.scss';
import PartnerLogo from '../../PartnersComponents/PartnerLogo';

/**
 * 
 * @param {array} partners Array of partners
 * @param {function} onPartnerClick On some partner click callback. Returns partner
 * @returns {ReactComponent}
 */
const PartnersBaseView = ({partners = [], size = 'sm', base = true, onPartnerClick}) => {
    if (!partners?.length) {
        return (<></>)
    }

    return (
        <div className={`partners-base-view partners-base-view--${size}`}>
            {
                partners.map((partner) => (
                    <PartnerLogo
                        key={partner.id}
                        partner={partner}
                        size={size}
                        base={base}
                        onClick={onPartnerClick}
                    />
                ))
            }
        </div>
    )
};

export default PartnersBaseView;
